const pageTypes = require('./pageTypes.json');

function getPageType(key) {
    return pageTypes[key];
}

module.exports = getPageType;



// WEBPACK FOOTER //
// ../rum-pagetypes/src/index.js